import { IconScanSearch } from '../verify-report/VerifyReportIcons'

type Props = {
  ready?: boolean
}

export default function VerifyScanIndicator({ ready = false }: Props) {
  return (
    <div
      className={`verify-loading-scan${ready ? ' verify-loading-scan--success' : ''}`}
      aria-hidden="true"
    >
      {ready ? (
        <svg className="verify-loading-scan__check" width="32" height="32" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M20 6 9 17l-5-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <IconScanSearch className="verify-loading-scan__icon" />
      )}
    </div>
  )
}
